const state = {
 add_modal: false,
 view_modal: false,
 
 id: null,
 name: null,
 employment_type: null,
 type: null,
 vat_registered: null,
 uploaded_files: null,
 
 nationality: null,
 
 // reload_files: {
 //  client: false,
 //  contact: false,
 //  order: false,
 //  worker: false
 // },
 reload_files: false,
 
 tax_file: {
  view_modal: false,
  tax_file_type: null,
  file_path: null,
  file_uploaded_by: null,
  file_uploaded_date: null,
 },
 service_report_file: {
  view_modal: false,
  file_path: null,
  uploaded_by: null,
  uploaded_date: null // created at
 }
};

const actions = {};

const mutations = {
 SHOW_ADD_FILE_MODAL(state, payload) {
  state.add_modal = true;
  state.view_modal = false;
  state.id = payload.id;
  state.name = payload.name;
  state.employment_type = payload.employment_type;
  state.type = payload.type;
  state.vat_registered = payload.vat_registered;
  state.uploaded_files = payload.uploaded_files;
  state.nationality = payload.nationality;
 },
 SHOW_VIEW_FILE_MODAL(state, payload) {
  state.add_modal = false;
  state.view_modal = true;
  state.id = payload.id;
  state.name = null;
  state.employment_type = null;
  state.type = payload.type;
  state.vat_registered = null;
  state.uploaded_files = null;
  state.nationality = null;
 },
 SHOW_VIEW_TAX_FILE_MODAL(state, payload) {
  state.tax_file.view_modal = true;
  state.tax_file.tax_file_type = payload.tax_file_type;
  state.tax_file.file_path = payload.file_path;
  state.tax_file.file_uploaded_by = payload.file_uploaded_by;
  state.tax_file.file_uploaded_date = payload.file_uploaded_date;
 },
 SHOW_VIEW_SERVICE_REPORT_MODAL(state, payload) {
  state.service_report_file.view_modal = true
  state.service_report_file.file_path = payload.file_path
  state.service_report_file.uploaded_by = payload.uploaded_by
  state.service_report_file.uploaded_date = payload.uploaded_date
 },
 HIDE_FILE_MODAL(state) {
  state.add_modal = false;
  state.view_modal = false;
  state.id = null;
  state.name = null;
  state.employment_type = null;
  state.type = null;
  state.vat_registered = null;
  state.uploaded_files = null;
  state.nationality = null;
 },
 HIDE_FILE_TAX_MODAL(state) {
  state.tax_file.view_modal = false;
  state.tax_file.tax_file_type = null;
  state.tax_file.file_path = null;
  state.tax_file.file_uploaded_by = null;
  state.tax_file.file_uploaded_date = null;
 },
 HIDE_SERVICE_REPORT_MODAL(state) {
  state.service_report_file.view_modal = false
  state.service_report_file.file_path = null
  state.service_report_file.uploaded_by = null
  state.service_report_file.uploaded_date = null
 },
 RELOAD_FILES(state, payload) {
  state.reload_files = payload.action
  // if (payload.type === 'client') {
  //  state.reload_files.client = payload.action;
  // }
  // else if (payload.type === 'contact') {
  //  state.reload_files.contact = payload.action;
  // }
  // else if (payload.type === 'order') {
  //  state.reload_files.order = payload.action;
  // }
  // else if (payload.type === 'worker') {
  //  state.reload_files.worker = payload.action;
  //  console.log('state: ' + state.reload_files.worker)
  // }
 },
};

export default {
 state,
 actions,
 mutations
}
